// Ported from EnterpriseTemplates react-project-template (Release 1.3.1), PMS slice 4b.
// ============================================================================
// ORG ADMIN ENDPOINTS — /api/v1/org/*
// ============================================================================

import { buildEndpoint, buildEndpointWithParams, buildEndpointWithQuery } from './base.endpoints';
import type { ID } from '../types';
import type { OrganisationKind } from '../types/organisation.types';

const BASE_PATH = '/org';

export const organisationEndpoints = {
  /** GET (paged) and POST */
  list: (kind: OrganisationKind) => buildEndpointWithParams(`${BASE_PATH}/:kind`, { kind }),

  /**
   * GET with paging / search. Built from the bare path: passing list() to buildEndpointWithQuery
   * added the version prefix twice (/api/v1/v1/org/entities → 404, an empty grid). The template
   * (react-project-template 1.3.1) has the same bug.
   */
  listWithQuery: (kind: OrganisationKind, query: Record<string, any>) =>
    buildEndpointWithQuery(`${BASE_PATH}/${kind}`, query),

  /** PATCH one row by LOCAL id */
  byId: (kind: OrganisationKind, id: ID) => buildEndpointWithParams(`${BASE_PATH}/:kind/:id`, { kind, id }),

  /** GET: entity and business-unit type codes */
  lookups: () => buildEndpoint(`${BASE_PATH}/lookups`),

  /** POST ?force=true|false — reconcile the projection with the master */
  sync: (force = false) => `${buildEndpoint(`${BASE_PATH}/sync`)}?force=${force ? 'true' : 'false'}`,

  /** GET — compare the projection with the master */
  verify: () => buildEndpoint(`${BASE_PATH}/verify`),
} as const;

export default organisationEndpoints;
